module.exports = __webpack_public_path__ + "img/007_thumbnail.01aa84fe.jpg";